
import { styled } from "@mui/material/styles";
import { Typography, TypographyProps } from "@mui/material";

export interface CustomFormLabelProps extends TypographyProps {
  highlight?: boolean;
}

export const CustomFormLabel = styled(
  ({ highlight, ...props }: CustomFormLabelProps) => (
    //@ts-ignore
    <Typography
      variant="body1"
      {...props}
      component="label"
    // htmlFor="label"
    />
  ),
  {
    shouldForwardProp: (prop) => prop !== "highlight",
  }
)<CustomFormLabelProps>(({ theme, highlight }) => ({
  marginBottom: "5px",
  marginTop: "15px",
  display: "block",
  color: theme.palette.mode === "dark" ? "#fff" : "rgb(89, 89, 89)",
  ...(highlight && {
    color: theme.palette.mode === "dark" ? "#fff59d" : "#b45309",
  }),
}));

export const CustomTypography = styled((props: TypographyProps) => (
  <Typography {...props} />
))(({ theme }) => ({
  color: theme.palette.mode === "dark" ? "#e6e5e8" : "rgb(0, 0, 0)",
}));


export const CustomLightTypography = styled((props: TypographyProps) => (
  <Typography {...props} />
))(({ theme }) => ({
  color: theme.palette.mode === "dark" ? "#e6e5e8" : "rgba(0, 0, 0, 0.54)",
}));
